import { render } from "./Imprint.vue?vue&type=template&id=67d8f947&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"

import "./Imprint.vue?vue&type=style&index=0&id=67d8f947&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d8f947"]])

export default __exports__